import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Button from '../components/common/Button';
import { toast } from 'react-toastify';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();

    if (!email || !password) {
      toast.error('Please enter email and password');
      return;
    }

    setLoading(true);

    try {
      await login(email, password, rememberMe);
      toast.success('Login successful!');
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      className="min-h-screen bg-cover bg-no-repeat relative bg-[center_top] sm:bg-center"
      style={{ backgroundImage: 'url(/login-bg.jpg)' }}
    >
      {/* Dark Overlay - lighter to show more background through glassmorphism */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Content */}
      <div className="relative z-10 min-h-screen flex items-center justify-center px-4 xs:px-6 sm:px-8 py-6 sm:py-12">
        <div className="max-w-md w-full">
          {/* Logo/Brand - scaled down for mobile */}
          <div className="text-center mb-4 sm:mb-8">
            <img
              src="/logo.png"
              alt="TenQ CRM"
              className="h-20 xs:h-24 sm:h-32 mx-auto mb-2 sm:mb-4 neon-glow-gold"
            />
            <p className="text-white/80 text-sm sm:text-lg">
              Interior Design & Renovation Management
            </p>
          </div>

          {/* Login Card - Glassmorphism effect */}
          <div className="bg-white/70 xs:bg-white/75 backdrop-blur-md rounded-xl shadow-gold-lg p-5 xs:p-6 sm:p-8 border border-white/30">
            <h2 className="text-xl sm:text-2xl font-display font-bold text-tenq-black mb-4 sm:mb-6 text-center">
              Welcome Back
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
              {/* Email */}
              <div>
                <label className="label text-xs sm:text-sm">
                  Email Address
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input"
                  placeholder="Enter your email"
                  autoComplete="email"
                  required
                />
              </div>

              {/* Password */}
              <div>
                <label className="label text-xs sm:text-sm">
                  Password
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="input"
                  placeholder="Enter your password"
                  autoComplete="current-password"
                  required
                />
              </div>

              {/* Remember Me */}
              <div className="flex items-center">
                <input
                  id="remember-me"
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  className="h-4 w-4 text-tenq-gold border-gray-300 rounded focus:ring-tenq-gold"
                />
                <label htmlFor="remember-me" className="ml-2 block text-xs sm:text-sm text-gray-700">
                  Remember me for 30 days
                </label>
              </div>

              {/* Submit Button */}
              <Button
                type="submit"
                variant="primary"
                className="w-full"
                loading={loading}
              >
                Sign In
              </Button>
            </form>

          </div>

          {/* Footer - Hidden on mobile */}
          <div className="hidden sm:block text-center mt-8">
            <p className="text-white/60 text-sm">
              &copy; 2026 TenQ CRM. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
